<cdx-dropdown
  class="lang-cdx"
  [options]="langDropdown"
  [maxWidthButton]="140"
  [maxWidthOptions]="160"
  [dropdownValid]="true"
  [(selectedItem)]="selectedLang"
  (selectedItemChange)="onSelectedChanged($event)">
</cdx-dropdown>